module.exports = __webpack_public_path__ + "bb24dcec0657042c44686bbda458a5.png";